import { render, staticRenderFns } from "./card-loading-module.vue?vue&type=template&id=2dce1530&scoped=true&lang=pug&"
import script from "./card-loading-module.vue?vue&type=script&lang=js&"
export * from "./card-loading-module.vue?vue&type=script&lang=js&"
import style0 from "./card-loading-module.vue?vue&type=style&index=0&id=2dce1530&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce1530",
  null
  
)

export default component.exports